import React, { Component } from "react";
import styled from "styled-components";
import logo from "../../../../assets/logo.png";
import { StyledNavLink } from "../../../theme/index";
import Avatar from "../../../shared/Avatar";
import DropdownModal from "../../../shared/DropdownModal";
import { connect } from "react-redux";
import { fetchProfile } from "../../../shared/redux/actions";
import LiveChat from "react-livechat";

export const A = styled.a`
  font-size: 18px;
  font-family: "Ubuntu", sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  list-style: none;
  color: #fff;
  font-weight: 600;
  margin-right: 2em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @media (max-width: 1100px) {
    font-size: 1.2em;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  height: 115px;
  width: 100%;
  background: #082841;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.img`
  width: 202px;
  margin: 0 3em;
  @media (max-width: 1100px) {
    width: 235px;
    height: 42px;
    margin-left: 1em;
  }
`;

class ChangePasswordHeader extends Component {
  state = {
    firstName: "",
    lastName: "",
    state: "",
    profession: ""
  };

  componentDidMount() {
    if (this.isAuthenticated()) {
      this.props
        .fetchProfile()
        .then(action => {
          this.setState({
            firstName: action.data.firstname || "",
            lastName: action.data.lastname || "",
            state: action.data.state || "",
            profession: action.data.profession || ""
          });
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      console.log("error");
    }
  }

  getInitials = () => {
    if (this.isAuthenticated()) {
      let name = `${this.state.firstName} ${this.state.lastName}`;
      let initials = name.match(/\b\w/g) || [];
      initials = (
        (initials.shift() || "") + (initials.pop() || "")
      ).toUpperCase();
      return initials;
    } else {
      console.log("not authenticated");
    }
  };

  onClickOption = () => {
    this.livechat.open_chat_window();
  };

  onClickExternal = val => {
    window.location.href = val.link;
  };

  logout = val => {
    this.props.history.push(val.link);
    localStorage.clear();
  };

  getOptions = () => {
    return [
      {
        label: "My Courses",
        link: "https://learn.achievece.com/enrollments",
        onClick: this.onClickExternal
      },
      {
        label: "My Certificates",
        link: "https://learn.achievece.com/account/certificates",
        onClick: this.onClickExternal
      },
      {
        label: "My Account",
        link: "https://learn.achievece.com/account",
        onClick: this.onClickExternal
      },
      {
        label: "Support",
        onClick: this.onClickOption
      },
      {
        label: "Sign Out",
        link: "/",
        onClick: this.logout
      }
    ];
  };

  isAuthenticated = () => {
    return localStorage.getItem("authorization");
  };

  render() {
    return (
      <HeaderWrapper>
        <LiveChat
          onChatLoaded={ref => (this.livechat = ref)}
          license={10146992}
        />
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Logo src={logo} />
          <StyledNavLink to="/findce">Find CE</StyledNavLink>
          <A href="https://learn.achievece.com/enrollments">My Courses</A>
        </div>
        <Avatar
          initials={this.getInitials() || null}
          background="#FFAF77"
          render={display => (
            <DropdownModal options={this.getOptions()} display={display} />
          )}
        />
      </HeaderWrapper>
    );
  }
}

export default connect(
  null,
  { fetchProfile }
)(ChangePasswordHeader);



// WEBPACK FOOTER //
// ./src/components/screens/ChangePassword/components/ChangePasswordHeader.jsx